export default __webpack_public_path__ + "static/media/photosDefaultLeft.95702229.png";